export default __webpack_public_path__ + "static/media/connector.5b7aa39b.png";